export const ACTION_TYPES = [
  'projectData/removeVisualMediaItem',
  'projectData/updateMediaItem',
  'projectData/splitVisualMediaItem',
  'projectData/duplicateVisualMediaItem',
  'projectData/uploadFromMediaLibrary',
  'projectData/addMultiLineAudios',
  'projectData/updateAudioItem',
  'projectData/removeAudiosFromProject',
  'projectData/splitAudioItem',
  'projectData/duplicateAudioItem',
  'projectData/updateActiveAudioVolume',
  'projectData/updateSoundVersion',
  'projectData/updateTtsAudios',
  'projectData/updateUploadedMediaFilePaths',

  'projectData/addMediaItems',
  'projectData/setMediaItems',
  'projectData/setMultilineAudios',
  // 'projectData/updateUploadedMediaItems',
  'projectData/removeTimelineSelectedItems',
  'projectData/updateTimelineItems'
]

export const ACTION_TYPES_UPDATING_UNDO_REDO_MEDIA_ITEMS = [
  'projectData/updateUploadedMediaItems',
  'projectData/updateMediaItemWithoutUndoSave'
]

export const ACTION_TYPES_UPDATING_UNDO_REDO_AUDIO_ITEMS = [
  'projectData/updateUploadedAudioFilePaths'
]
